import { Helper } from '@/mixin/helper'
import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']

export default [
  {
    path: '/master/contract/customer/create',
    name: 'Master Customer Contract Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, __, next) {
        if (!hasAccessAll([
          'tms-customer-contract:create',
          'tms-customer-contract:read',
          'tms-customer-contract:update',
          'tms-customer-contract:delete',
        ])) {
          return next({ name: '403'})
        }

        Helper.methods.userLogging('Access', _)
        next()
      }
    },
    component: () => import('@/router/views/master/contract/customer-contract/form'),
  },
  {
    path: '/master/contract/customer/:contractId',
    name: 'Master Customer Contract Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, __, next) {
        if (!hasAccessAll([
          'tms-customer-contract:create',
          'tms-customer-contract:read',
          'tms-customer-contract:update',
          'tms-customer-contract:delete',
        ])) {
          return next({ name: '403'})
        }

        Helper.methods.userLogging('Access', _)
        next()
      }
    },
    component: () => import('@/router/views/master/contract/customer-contract/form'),
  },
]